import { create } from 'zustand'
import { dbgEvent } from '../lib/debug'

interface MetricsSessionState {
  model: string | null
  totalCost: number
  contextUsage: number | null
}

interface MetricsStoreState {
  sessions: Record<string, MetricsSessionState>
  setModel: (sessionId: string, model: string) => void
  setCost: (sessionId: string, cost: number) => void
  setContextUsage: (sessionId: string, percentage: number | null) => void
  initSession: (sessionId: string, model?: string) => void
}

export const useMetricsStore = create<MetricsStoreState>((set) => ({
  sessions: {},

  setModel: (sessionId, model) => {
    dbgEvent('Zustand', 'metrics.setModel', { sessionId: sessionId.slice(0, 8), model })
    set(state => {
      const session = state.sessions[sessionId] ?? { model: null, totalCost: 0, contextUsage: null }
      return {
        sessions: {
          ...state.sessions,
          [sessionId]: { ...session, model },
        },
      }
    })
  },

  setCost: (sessionId, cost) => {
    // cost recu du daemon EST DEJA le cumul de la session (total_cost_usd du SDK,
    // cumulatif au niveau du process claude, jamais reset entre tours) -> on ecrase,
    // on n'additionne pas. Cf. journal #10484 (BUG4a).
    dbgEvent('Zustand', 'metrics.setCost', { sessionId: sessionId.slice(0, 8), totalCost: cost })
    set(state => {
      const session = state.sessions[sessionId] ?? { model: null, totalCost: 0, contextUsage: null }
      return {
        sessions: {
          ...state.sessions,
          [sessionId]: { ...session, totalCost: cost },
        },
      }
    })
  },

  setContextUsage: (sessionId, percentage) => {
    set(state => {
      const session = state.sessions[sessionId] ?? { model: null, totalCost: 0, contextUsage: null }
      return {
        sessions: {
          ...state.sessions,
          [sessionId]: { ...session, contextUsage: percentage },
        },
      }
    })
  },

  initSession: (sessionId, model) => {
    set(state => {
      if (state.sessions[sessionId]) return state
      return {
        sessions: {
          ...state.sessions,
          [sessionId]: { model: model ?? null, totalCost: 0, contextUsage: null },
        },
      }
    })
  },
}))
